import { useRouter } from 'next/router';
import type { ShopSchema } from 'src/models/shop/schema';
import { checkLocaleCn } from 'src/utils/locale';
import { convertLocaleForGoogleMap } from 'src/utils/map';

export const useMapProvider = (shop: ShopSchema | undefined) => {
  const { locale } = useRouter();

  const openMapApp = () => {
    if (!shop || checkLocaleCn(locale)) return;

    const { latitude, longitude } = shop;
    const geoUrl = `geo:${latitude},${longitude}`;
    const webUrl = `https://www.google.com/maps?q=${latitude},${longitude}&hl=${convertLocaleForGoogleMap(locale)}`;
    // Attempt to open the map app
    window.location.href = geoUrl;
    // Set a timer to check if it fails, then open web version in a new tab
    setTimeout(() => {
      if (document.hasFocus()) {
        window.open(webUrl, '_blank'); // Open Google Maps web version in a new tab
      }
    }, 1000);
  };

  return {
    openMapApp
  };
};
